import { Animation, createAnimation } from '@ionic/angular';

/**
 * Animación de entrada/salida para las hojas apiladas de acciones secundarias En `mode: 'md'` Ionic
 * anima el modal con un translateY(40px) + fade de 280ms En escritorio la hoja no aplica
/**  */
const MOBILE_MAX_WIDTH = 767;

const SHEET_EASING = 'cubic-bezier(0.32, 0.72, 0, 1)';
const SHEET_ENTER_DURATION = 400;
const SHEET_LEAVE_DURATION = 300;

const CARD_EASING = 'cubic-bezier(0.36, 0.66, 0.04, 1)';
const CARD_DURATION = 240;

const BACKDROP_LEAVE_DURATION = 180;
const SHEET_IN_CLASS = 'sheet-in';
const SHEET_OUT_CLASS = 'sheet-out';

const isSheet = (): boolean => window.innerWidth <= MOBILE_MAX_WIDTH;

const getParts = (baseEl: HTMLElement) => {
    const root: ParentNode = baseEl.shadowRoot ?? baseEl;

    return {
        backdrop: root.querySelector('ion-backdrop'),
        wrapper: root.querySelector('.modal-wrapper'),
    };
};

export const sheetModalEnterAnimation = (baseEl: HTMLElement): Animation => {
    const { backdrop, wrapper } = getParts(baseEl);

    const backdropAnimation = createAnimation()
        .addElement(backdrop)
        .fromTo('opacity', 0.01, 'var(--backdrop-opacity)')
        .beforeStyles({ 'pointer-events': 'none' })
        .afterClearStyles(['pointer-events']);

    const wrapperAnimation = createAnimation().addElement(wrapper);

    if (isSheet()) {
        wrapperAnimation.keyframes([
            { offset: 0, opacity: 1, transform: 'translateY(100%)' },
            { offset: 1, opacity: 1, transform: 'translateY(0)' },
        ]);
    } else {
        wrapperAnimation.keyframes([
            { offset: 0, opacity: 0.01, transform: 'scale(0.96)' },
            { offset: 1, opacity: 1, transform: 'scale(1)' },
        ]);
    }

    return createAnimation()
        .addElement(baseEl)
        .beforeAddClass(SHEET_IN_CLASS)
        .easing(isSheet() ? SHEET_EASING : CARD_EASING)
        .duration(isSheet() ? SHEET_ENTER_DURATION : CARD_DURATION)
        .addAnimation([backdropAnimation, wrapperAnimation]);
};

export const sheetModalLeaveAnimation = (baseEl: HTMLElement): Animation => {
    const { backdrop, wrapper } = getParts(baseEl);

    const backdropAnimation = createAnimation()
        .addElement(backdrop)
        .duration(isSheet() ? BACKDROP_LEAVE_DURATION : CARD_DURATION)
        .easing('linear')
        .fromTo('opacity', 'var(--backdrop-opacity)', 0);

    const wrapperAnimation = createAnimation().addElement(wrapper);

    if (isSheet()) {
        wrapperAnimation.keyframes([
            { offset: 0, opacity: 1, transform: 'translateY(0)' },
            { offset: 1, opacity: 1, transform: 'translateY(100%)' },
        ]);
    } else {
        wrapperAnimation.keyframes([
            { offset: 0, opacity: 1, transform: 'scale(1)' },
            { offset: 1, opacity: 0, transform: 'scale(0.96)' },
        ]);
    }

    return createAnimation()
        .addElement(baseEl)
        .beforeRemoveClass(SHEET_IN_CLASS)
        .beforeAddClass(SHEET_OUT_CLASS)
        .easing(isSheet() ? SHEET_EASING : CARD_EASING)
        .duration(isSheet() ? SHEET_LEAVE_DURATION : CARD_DURATION)
        .addAnimation([backdropAnimation, wrapperAnimation]);
};
